import { Flex, FlexProps, theme } from 'antd'
import React from 'react'

const { useToken } = theme

type Props = FlexProps & { direction?: 'up' | 'down'; height?: string }

export const FlexGradient: React.FC<Props> = ({
  children,
  direction = 'down',
  height = '100px',
  style = {},
  ...props
}) => {
  const { token } = useToken()

  return (
    <>
      <Flex vertical style={{ ...style }}>
        {direction === 'up' && (
          <div
            style={{
              width: '100%',
              height,
              background: `linear-gradient(to top, ${token.colorBgBase}, transparent)`,
            }}
          >
            {' '}
          </div>
        )}

        <Flex
          {...props}
          style={{
            background: token.colorBgBase,
          }}
        >
          {children}
        </Flex>

        {direction === 'down' && (
          <div
            style={{
              width: '100%',
              height,
              background: `linear-gradient(to bottom, ${token.colorBgBase}, transparent)`,
            }}
          >
            {' '}
          </div>
        )}
      </Flex>
    </>
  )
}
